import { render, staticRenderFns } from "./ContentOneColumn.vue?vue&type=template&id=18821d8a&"
import script from "./ContentOneColumn.vue?vue&type=script&lang=ts&"
export * from "./ContentOneColumn.vue?vue&type=script&lang=ts&"
import style0 from "./ContentOneColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockWrapper: require('/tmp/build_4600e676/src/components/block/BlockWrapper.vue').default})
